import React, { Component } from 'react'
import { Link, HashRouter } from 'react-router-dom'
import { setRegPage, currentWidget, popupOpenClose, setDeviceConfigFailed, setMobileTVPage, setFailScreen, openSMSWidget, setOpenProfileImage } from '../../action/action'
import { connect } from 'react-redux'
import { nonCompWidgetClick } from '../../layout2.0/JS/widgetHandling'
import { setRoomControlPage } from '../../layout2.0/action/action'
import { setOpenDemoCamera, setGoHome, setLoader, setLoginRequired, setExternalSignIn, setDNDon, setMURon } from '../../layout2.0/action/homeAction'
import { closeOrderPopUp } from '../../layout2.0/action/hCommerce2'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { guestDetails, sendAnalytics } from "../../action/homeAction"
import { sendAcCommand } from '../../action/roomControlAction'
import { withTranslation } from 'react-i18next'
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction'
import { isUserLoggedin } from '../../layout2.0/components/hotelSelector/hotelSelector'
import { getCdnUrl } from '../../config/config'
import { CMSPath } from '../../config/constant'

class HorizontalSingleSmallWidget extends Component {

    constructor(props) {
        super(props);
        this.state = {
            widgetData: {}
        }
    }

    componentDidMount() {
        if (this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }

    componentDidUpdate(preProb) {
        if (preProb.widgetList !== this.props.widgetList && this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }

    setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                this.props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                this.props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                this.props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                this.props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }

    onWidgetClick = async (widget) => {
        let room = localStorage.getItem('room')
        console.log("current widget", widget)
        if (widget.path) {
            await this.props.currentWidget(widget);
            if (widget.path === "/RoomControl2") {
                this.setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/happy") {
                if(this.props.survey.needsLogin)
                if(!room || room === "null"){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                }
            }
            if (widget.path === "/mobileTv") {
                if(!room){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                } else {
                    this.props.setMobileTVPage(true);
                }

            }
            if (widget.widgetType === "Hcommerce") {
                this.props.setHcommerceWidget(widget);
            }
        } else {
            nonCompWidgetClick(widget, this.props)
        }
    }

    render() {
        return (
            <Link 
                onClick={() => this.onWidgetClick(this.state.widgetData)}
                exact to={this.state.widgetData.path ? this.state.widgetData.path : "/"}
                class={`tile-selection tile-container ${this.state.widgetData.widgetType == "Guest Details" ? `widget-info  ${isUserLoggedin()?"_logged-in_":"_logged-out_"}` : ""} ${this.state.widgetData.widgetMetaHtmlId?this.state.widgetData.widgetMetaHtmlId:""} ${this.state.widgetData.widgetType}`}>
                <div class="tile-selection-img">
                    {this.state.widgetData.compImage ?
                        <img 
                        // src={this.state.widgetData.compImage}
                        src={getCdnUrl(CMSPath, this.state.widgetData.widgetHeaderImageUrl || this.state.widgetData.btnImageUrl)}
                        ></img> :
                        ""
                    }
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.96 39.96"><title>Remote</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M39.06,13.9l-13-13A3.09,3.09,0,0,0,21.7.9L3.51,19.09a12,12,0,0,0,0,17l.39.39a12,12,0,0,0,17,0L39.06,18.26A3.09,3.09,0,0,0,39.06,13.9Zm-4-2.09a1.5,1.5,0,1,1-2.12,0A1.49,1.49,0,0,1,35.11,11.81Zm-7-7a1.5,1.5,0,1,1-2.12,0A1.49,1.49,0,0,1,28.15,4.85ZM5,28a1.5,1.5,0,1,1,2.12,0A1.49,1.49,0,0,1,5,28ZM8.2,24.8a1.5,1.5,0,1,1,2.12,0A1.49,1.49,0,0,1,8.2,24.8Zm3.24-3.24a1.5,1.5,0,1,1,2.12,0A1.49,1.49,0,0,1,11.44,21.56ZM5.12,34.84a1.51,1.51,0,1,1,2.13,0A1.52,1.52,0,0,1,5.12,34.84Zm3.32-3.32a1.5,1.5,0,1,1,2.12,0A1.49,1.49,0,0,1,8.44,31.52Zm3.24-3.24a1.5,1.5,0,1,1,2.12,0A1.49,1.49,0,0,1,11.68,28.28ZM14.92,25A1.5,1.5,0,1,1,17,25,1.49,1.49,0,0,1,14.92,25Zm-3,10A1.5,1.5,0,1,1,14,35,1.49,1.49,0,0,1,11.92,35Zm3.24-3.24a1.5,1.5,0,1,1,2.12,0A1.49,1.49,0,0,1,15.16,31.76Zm3.24-3.24a1.5,1.5,0,1,1,2.12,0A1.49,1.49,0,0,1,18.4,28.52Zm-.84-6.12a7.7,7.7,0,1,1,10.89,0A7.7,7.7,0,0,1,17.56,22.4Z" /></g></g></svg> */}
                </div>
                <div class="tile-selection-text">
                    <div class="tile-selection-heading" dangerouslySetInnerHTML={{__html: this.state.widgetData.widgetTitle ? this.state.widgetData.widgetTitle : ""}} ></div>
                    <div class="tile-selection-desc" dangerouslySetInnerHTML={{__html: this.state.widgetData.widgetDesc ? this.state.widgetData.widgetDesc : ""}} ></div>
                </div>
            </Link>
        )
    }
}


HorizontalSingleSmallWidget.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        externalSignIn: state.store2.externalSignIn,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}
export default connect(
    mapStateToProps,
    {
        currentWidget,
        popupOpenClose,
        openSMSWidget,
        setOpenProfileImage,
        setRoomControlPage,
        setDeviceConfigFailed,
        setOpenDemoCamera,
        setRegPage,
        setDNDon,
        setMURon,
        sendAcCommand,
        closeOrderPopUp,
        setHcommerceWidget,
        setMobileTVPage,
        guestDetails,
        sendAnalytics,
        setGoHome,
        setLoader,
        setFailScreen,
        setLoginRequired,
        setOpenExternalLinkInSameTab,
        setExternalSignIn
    }
)(withTranslation('translations')(HorizontalSingleSmallWidget));